import { render } from "./Amige.vue?vue&type=template&id=663e4842&scoped=true"
const script = {}

import "./Amige.vue?vue&type=style&index=0&id=663e4842&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663e4842"]])

export default __exports__